import React from 'react';
import { Row, Col, Form, Switch, Typography } from 'antd';

const { Title, Text } = Typography;

const TabParticipantTypes = ({ participantTypes }) => (
    <>
        <Row style={{ marginBottom: 8 }}>
            <Col span={24}>
                <Title level={4} style={{ margin: 0 }}>Blacklist</Title>
            </Col>
        </Row>
        <Row style={{ marginBottom: 30 }}>
            <Col span={24}>
                <Text type="secondary">
                    Select the types of participants that cannot print badges in this device configuration.
                </Text>
            </Col>
        </Row>
        <Row gutter={[16, 16]}>
            {participantTypes.length > 0 &&
                participantTypes.map((participantType) => {
                    const nameObj = participantType.name.find(n => n.lang === "en") || participantType.name[0];
                    const nameValue = nameObj ? nameObj.value : "Unnamed";

                    return (
                        <Col key={participantType.id} xs={24} sm={12} md={12} lg={6}>
                            <Form.Item
                                name={`participantType_${participantType.id}`}
                                valuePropName="checked"
                                label={nameValue}
                            >
                                <Switch defaultChecked={false} />
                            </Form.Item>
                        </Col>
                    );
                })}
        </Row>
    </>
);

export default TabParticipantTypes;